import {Descriptor} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-descriptor"

export const determineDescriptor = (sourceDescriptor: Descriptor, resultChannels?: number): Descriptor => {
    const numPatches = sourceDescriptor.batching?.numPatches ?? {x: 1, y: 1}
    return {
        width: numPatches.x,
        height: numPatches.y,
        channels: resultChannels ?? sourceDescriptor.channels,
        batching:
            numPatches.x > 1 || numPatches.y > 1
                ? {
                      numPatches,
                      patchSize: {width: 1, height: 1},
                  }
                : undefined,
    }
}
